import App from '@/App.vue';
import { i18n } from '@/i18n';
import router from '@/router';
import { supabase } from '@/supabase';
import * as Sentry from '@sentry/vue';
import { supabaseIntegration } from '@supabase/sentry-js-integration';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createVfm } from 'vue-final-modal';

import '@/assets/main.css';

const dsn: string = import.meta.env.VITE_SENTRY_DSN as string;
const app = createApp(App);
const supabaseClient = supabase;

Sentry.init({
  app,
  dsn,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    supabaseIntegration(supabaseClient, Sentry, {
      breadcrumbs: true,
      errors: true,
      tracing: true,
    }),
  ],
  // Tracing
  tracePropagationTargets: ['localhost'],
  tracesSampleRate: 1.0,
});

app.use(createPinia());
app.use(createVfm());
app.use(i18n);
app.use(router);

app.mount('#app');
